"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _selectors = require("../../../selectors");
var _ActionButtons = _interopRequireDefault(require("../../ui/ActionButtons"));
var _MessageInputBar = _interopRequireDefault(require("../../ui/MessageInputBar"));
var _MessageInputLock = _interopRequireDefault(require("../../ui/MessageInputLock"));
var _style = require("./style");
var _adUtil = require("../../../helpers/adUtil");
var _types = require("../../../actions/types");
var _actions = require("../../../actions");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var MessageInput = function MessageInput(_ref) {
  var lock = _ref.lock,
    isAdview = _ref.isAdview,
    secondHidden = _ref.secondHidden,
    setPredefinedHidden = _ref.setPredefinedHidden;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
    children: [!lock && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ActionButtons["default"], {
        isAdview: isAdview,
        setPredefinedHidden: setPredefinedHidden,
        secondHidden: secondHidden
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageInputBar["default"], {})]
    }), lock && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageInputLock["default"], {
      lock: lock
    })]
  });
};
MessageInput.propTypes = {
  lock: _propTypes["default"].bool.isRequired,
  setPredefinedHidden: _propTypes["default"].func.isRequired,
  secondHidden: _propTypes["default"].bool.isRequired,
  isKeyboardOpened: _propTypes["default"].bool
};
var mapStateToProps = function mapStateToProps(state) {
  var partnerStatus = (0, _selectors.getCurrentPartnerStatus)(state);
  var _getCurrentChat = (0, _selectors.getCurrentChat)(state),
    adStatus = _getCurrentChat.adStatus;
  return {
    lock: partnerStatus && partnerStatus !== _types.PARTNERS_STATUS.VALID || (0, _adUtil.isAdInactive)(adStatus)
  };
};
var _default = exports["default"] = (0, _actions.connect)(mapStateToProps)(MessageInput);